import { config } from "../../../../../helpers/config_global";
import React, { Component, Fragment } from "react";
import {
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService";

import apiResponse from "../../../../../services/apiResponse";
import IndexBloc from "../Blocs/IndexBloc";
import MinioClient from "../../../../../services/minioClient";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  if (date) {
    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
  }

  return "-";
};

class DecreeTableComponent extends Component {
  indexBloc = new IndexBloc();
  minioClient = new MinioClient();
  source;
  historyTable = "DecreePPOTableActive";
  defaultOrder = "employee_transfer_detail_create_date";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      tokenAPICalled: false,
      // updateSKModal: false,
      // tooltipOpen: false,
    };
  }

  // toggleTooltip = () => this.setState({ tooltipOpen: !this.state.tooltipOpen });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      uuid: this.props.uuid,
    };
    await this.indexBloc.fetchHistory(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.indexBloc.historyChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentDidUpdate(prevProps) {
    // Check if modal opened or a different row (employee_transfer_detail_uuid) is clicked
    if (
      this.props.modal &&
      (!prevProps.modal || prevProps.uuid !== this.props.uuid)
    ) {
      // Call the API only when modal opens or uuid changes
      this.setTokenAPI();
      this.setState({ tokenAPICalled: true });
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (!prevProps.modal && this.props.modal && !this.state.tokenAPICalled) {
  //     // Only call setTokenAPI when modal transitions from false to true
  //     this.setTokenAPI();
  //     this.setState({ tokenAPICalled: true }); // Mark that token API was called
  //   }
  // }

  componentWillUnmount() {
    this.indexBloc.historyChannel?.unsubscribe();
  }

  columns = [
    // {
    //   key: "employee_transfer_detail_decree_number",
    //   text: "Nomor SK",
    //   sortable: true,
    //   cell: (record) => {
    //     return (
    //       <Fragment>
    //         <li>
    //           <ul>
    //             <li>
    //               <span style={{ minWidth: "100px", display: "inline-block" }}>
    //                 <b>Nomor SK</b>
    //               </span>{" "}
    //               <b>:</b> {record.employee_transfer_detail_decree_number}
    //             </li>
    //             <li>
    //               <span style={{ minWidth: "100px", display: "inline-block" }}>
    //                 <b>Tanggal SK</b>
    //               </span>{" "}
    //               <b>:</b>{" "}
    //               {reformatDate(record.employee_transfer_detail_decree_date)}
    //             </li>
    //             <li>
    //               <span style={{ minWidth: "100px", display: "inline-block" }}>
    //                 <b>TMT Mulai</b>
    //               </span>{" "}
    //               <b>:</b>{" "}
    //               {reformatDate(
    //                 record.employee_transfer_detail_tmt_date
    //                   ? record.employee_transfer_detail_tmt_date
    //                   : "-"
    //               )}
    //             </li>
    //             <li>
    //               <span style={{ minWidth: "100px", display: "inline-block" }}>
    //                 <b>TMT Berakhir</b>
    //               </span>{" "}
    //               <b>:</b>{" "}
    //               {reformatDate(
    //                 record.employee_transfer_detail_end_date
    //                   ? record.employee_transfer_detail_end_date
    //                   : "-"
    //               )}
    //             </li>
    //             {/* <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Dokumen</b></span> <b>:</b> {record?.document_decree != null ? <a target={"_blank"} href={record?.document_decree?.documents_path}>Download</a> : '-'}</li> */}
    //           </ul>
    //         </li>
    //         {/*
    //         <br />
    //         <b>Nomor SK</b>
    //         <br />
    //         {record.employee_transfer_detail_decree_number}
    //         <br />
    //         <b>Tanggal SK</b>
    //         <br />
    //         {reformatDate(record.employee_transfer_detail_decree_date)}
    //         <br />
    //         <b>TMT Mulai</b>
    //         <br />
    //         {reformatDate(record.employee_transfer_detail_tmt_date)}
    //         <br />
    //         <b>TMT Berakhir</b>
    //         <br />
    //         {record.employee_transfer_detail_tmt_date_end
    //           ? reformatDate(record.employee_transfer_detail_tmt_date_end)
    //           : "-"} */}
    //       </Fragment>
    //     );
    //   },
    // },

    {
      key: "employee_transfer_detail_decree_number",
      text: "Nomor SK",
      sortable: true,
      cell: "-",
    },

    {
      key: "employee_transfer_detail_decree_date",
      text: "Tanggal SK",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_decree_date
          ? reformatDate(record.employee_transfer_detail_decree_date)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_tmt_date",
      text: "TMT Mulai",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_tmt_date
          ? reformatDate(record.employee_transfer_detail_tmt_date)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_end_date",
      text: "TMT Berakhir",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_tmt_date_end
          ? reformatDate(record.employee_transfer_detail_tmt_date_end)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_decree_document_uuid",
      text: "Dokumen SK",
      sortable: true,
      cell: (record) => {
        if (
          record.document_decree?.documents_path == null ||
          record.document_decree?.documents_path == ""
        ) {
          return (
            <label className="badge rounded-pill bg-soft-danger font-size-12">
              Tidak ada Dokumen
            </label>
          );
        } else {
          return (
            <a
              href="javascript:void(0)"
              className="btn btn-success btn-sm"
              onClick={() =>
                this.previewDocument(record.document_decree?.documents_path)
              }
              download
            >
              Download
            </a>
          );
        }
      },
    },

    {
      key: "employee_transfer_detail_create_date",
      text: "Tanggal dibuat",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_create_date
          ? reformatDate(record.employee_transfer_detail_create_date)
          : "-";
      },
    },
    {
      key: "employee_transfer_detail_log_name",
      text: "Status",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.employee_transfer_detail_log_name ? (
              <label
                className={`badge rounded-pill bg-soft-${record.employee_transfer_detail_log_label} font-size-12`}
              >
                {record.employee_transfer_detail_log_name}
              </label>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  previewDocument(url) {
    window.open(url, "_blank");
  }

  // previewDocumentMinio(urlPath) {
  //   this.setState({
  //     loading: true,
  //   });
  //   this.minioClient.get(urlPath).then((url) => {
  //     this.setState({
  //       loading: false,
  //     });
  //     window.open(url, "_blank");
  //     // alert(url)
  //   });
  // }

  render() {
    return (
      <Fragment>
        <Modal isOpen={this.props.modal} size="xl" toggle={this.props.toggle}>
          <ModalHeader toggle={this.props.toggle}>
            Riwayat Perubahan Dokumen SK
          </ModalHeader>
          <ModalBody>
            <hr></hr>
            <MKIDatatable
              className={this.configDatatable.tableClass}
              config={this.configDatatable}
              records={this.state.rows}
              columns={this.columns}
              dynamic={true}
              minWidth={1000}
              total_record={this.state.totalRow}
              initial={this.state.filter}
              onChange={(filter) => {
                this.setState(
                  {
                    loadingTable: true,
                    filter: filter,
                  },
                  function () {
                    this.setTokenAPI();
                  }
                );
              }}
              loading={this.state.loadingTable}
            />
          </ModalBody>
          {/* <ModalFooter>
            <Button color="secondary" onClick={this.props.toggle}>
              Cancel
            </Button>{" "}
            <Button color="primary" type="submit">
              Submit
            </Button>
          </ModalFooter> */}
        </Modal>
      </Fragment>
    );
  }
}

export default DecreeTableComponent;
